// <generated-client-wrappers:imports>
import * as WrapperCore from '@angular/core';
import type * as WrapperHttp from '@angular/common/http';
import type * as WrapperRx from 'rxjs';
import * as WrapperServices from '../generated/api/account.service';
// </generated-client-wrappers:imports>
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { HttpRequestOptions, SKIP_OPTION } from '@seech/auth-ng';
import { Observable } from 'rxjs';
import { OperationsApiRoutes } from '../constants/operations.constants';
import { OperationsUserSessionResponse } from '../models';
import { SubsiteHubResponse } from '@seech-sub/layout-ng';

@Injectable({
  providedIn: 'root',
})
export class AccountClientService {
  private readonly http = inject(HttpClient);

  login(): Observable<OperationsUserSessionResponse>;

  login(option: HttpRequestOptions): Observable<HttpResponse<OperationsUserSessionResponse>>;

  login(
    option?: HttpRequestOptions
  ): Observable<OperationsUserSessionResponse | HttpResponse<OperationsUserSessionResponse>> {
    if (!option) {
      return this.http.get<OperationsUserSessionResponse>(OperationsApiRoutes.accountLogin);
    }

    const context = (option.context ?? new HttpContext())
      .set(SKIP_OPTION.AUTHENTICATION, true)
      .set(SKIP_OPTION.HEADERS, true);

    return this.http.get<OperationsUserSessionResponse>(OperationsApiRoutes.accountLogin, {
      headers: option.headers,
      context,
      observe: 'response',
    });
  }

  getHub(): Observable<SubsiteHubResponse> {
    return this.http.get<SubsiteHubResponse>('/api/Account/hub');
  }
  // <generated-client-wrappers:methods>
  private readonly wrapperGeneratedClient = WrapperCore.inject(
    WrapperServices.AccountService,
    { optional: true },
  );

  logout(
    sessionId?: string,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<boolean> {
    if (!this.wrapperGeneratedClient)
      throw new Error('AccountService is not available');
    return this.wrapperGeneratedClient.accountLogout(
      sessionId,
      'body',
      reportProgress,
      options,
    );
  }
  // </generated-client-wrappers:methods>
}
